// Collabtic Firebase Config
const fcmApiKey = 'AIzaSyAjWje4VV-ZzbLKjt4FuhdflFTV_KbZnJw';
const fcmAuthDomain = 'collabtic-app.firebaseapp.com';
const fcmDbUrl = 'https://collabtic-app.firebaseio.com';
const fcmProjId = 'collabtic-app';
const fcmStorageBucket = 'collabtic-app.appspot.com';
const fcmSenderId = '550936066065';
const fcmAppId = '1:550936066065:web:501f01e0b60fa738bb59b0';

// MAHLE Firebase Config
/*var fcmApiKey = "AIzaSyCoAJgO0p3Q0Bj5ke0MHkH6BRGn_ijC_WI";
var fcmAuthDomain = "mahle-17089.firebaseapp.com";
var fcmDbUrl = "https://mahle-17089.firebaseio.com";
var fcmProjId = "mahle-17089";
var fcmStorageBucket = "mahle-17089.appspot.com";
var fcmSenderId = "438537718573";
var fcmAppId = "1:438537718573:web:f962e63fd562feb8fe61a4";*/


export const environment = {
  production: true,
  webVersionCollabtic: 13.06,
  webVersionKIA: 1.4,
  webVersionACX: 1.0,
  webVersionMAHLE: 2.2,
  webVersionTVS: 3.21,
  webVersionTVSIB: 2.1,
  webVersionCBA: 3.46,
  webVersionMAHLEEurope: 2.1,
  googleApiKey: 'AIzaSyAjWje4VV-ZzbLKjt4FuhdflFTV_KbZnJw',
  // commented 360 payments
  /* paymentKeys: {
    atg: 'jQdDdW-MAC7mM-7m8NtW-Cm5V39',
    collabtic: 'jQdDdW-MAC7mM-7m8NtW-Cm5V39'
  }, */
  firebase: {
    apiKey: fcmApiKey,
    authDomain: fcmAuthDomain,
    databaseURL: fcmDbUrl,
    projectId: fcmProjId,
    storageBucket: fcmStorageBucket,
    messagingSenderId: fcmSenderId,
    appId: fcmAppId,
  },
  auth: {
    clientId: '4e835741-d75c-4fbe-bf8a-13f6a7788ddd',
    authority: 'https://login.microsoftonline.com/common',
    // redirectUri: 'https://collabtic.in.ngrok.io/auth/integration'
    // redirectUri: 'https://forum.collabtic.com/cbt-v2/auth/integration'
    redirectUri: 'https://collabtic.fieldpulse.co/auth/integration',
  },
  theme: {
    default: {
      name: 'default',
      path: 'assets/json/default-theme.json'
    },
    cba: {
      name: 'cba',
      path: 'assets/json/cba-theme.json'
    }
  },
  stripe: {
    public: 'pk_test_51NnlHkAm6gQvtwLXv711Vk0yrt8OYMZSqHwzRavmlO8SWr7WhBTVRFThu0dYD1mKnbQHIvmhGe9haKmkKzhn9Y8n00SgQTXMm4',
    public_atg: 'pk_test_51OtZiIEUFFr9nBA5vCAS0FoBXWtHnl72c3DbXf5X2ME3CvkLrg2HGYtlZWIyCANvn2XZaHAt8mny2QNDNa3bDHTF00MYczZcHo',
    public_atgtraining: 'pk_test_51OtZiIEUFFr9nBA5vCAS0FoBXWtHnl72c3DbXf5X2ME3CvkLrg2HGYtlZWIyCANvn2XZaHAt8mny2QNDNa3bDHTF00MYczZcHo',
    public_autoshopanswers: 'pk_test_51PEar7CWkgdQo7rc1MuQSKd5dY5VKxj1LJpK8vxf9MgKKReqbWYQSidbgp1I6AhNqOzOMtYalQNf6rnlPT6DZpkr00g8FQshfw',
    public_autodiagclinic: 'pk_test_51Ozk4TC2Du7ZI9BbJ8SMLSCxvl0FfIJvocBSEkNSAVQ3T2QsTaRp2OqBkF463fUm8rc9o2Vy9X5vjISOYLsvoBtK00GFIHCgOR',
    public_lmv: 'pk_test_51QKjgdGGgMGqFdj5muINlnEhfwkDsh0FI4EdjJRd6leo3kQ4oTvci2ZypSYmzfcst1KQWWuC8TYHC7MNWlgJljXQ00S5aa7xlo',
    public_codysautodiagnostics: 'pk_test_51NnlHkAm6gQvtwLXv711Vk0yrt8OYMZSqHwzRavmlO8SWr7WhBTVRFThu0dYD1mKnbQHIvmhGe9haKmkKzhn9Y8n00SgQTXMm4',
    public_evtech: 'pk_test_51QKjgdGGgMGqFdj5muINlnEhfwkDsh0FI4EdjJRd6leo3kQ4oTvci2ZypSYmzfcst1KQWWuC8TYHC7MNWlgJljXQ00S5aa7xlo'
  },
  all_data: {
    baseUrl: `https://my.alldata.com`,
    authUrl: `https://my.alldata.com/#/authorization`,
    scope: 'read',
    redirect_uri: 'https://forum.collabtic.com',
    client_name: 'Collabtic',
    response_type: 'code',
    client_id: '44249640-6aac-4a2d-8bf3-0ba4511475e9',
    client_secret: 'e3dce146-bb71-4942-a1ee-9f9670038a39',
  }
};